import u from 'updeep';
import { handleActions } from 'redux-actions';
import * as actions from './allFluencesActions';

const initialState = {
  isFetchingFluences: false,
  isFetchingThemes: false,
  isFetchingThemeDetails: false,
  fluences: [],
  fluencyThemes: {
    themes: []
  },
  themeDetails: {
    lessons: []
  },
  isFetchingUserEnroll: false,
  isCheckingUserEnrolled: false,
  isUserEnrolled: false,
  enrollmentId: '',
  storyStatus: {},
  isFetchingEnrolledFluencies: false,
  userEnrolledFluency: [],
  isFetechingStorySuggestion: false,
  nextStorySuggestion: {},
  isRpOnboardingModalVisible: false,
  enrollmentDetails: {
    enrollmentDetails: {}
  },
  isFetchingLandginPageImages: false,
  landingPagesImages: {
    featureLinks: []
  },
  rpUserType: '',
  rpsSelectNumberOfStudents: '',
  nextThemeSuggestion: {},
  targetFluencyLevel: 0,
  isFetchingLandingPageContent: false,
  landingPageContent: {},
  storyLabel: {},
  isFetchingThemePageContent: false,
  themePageContent: {},
  isFetchingCertDownload: true,
  showSurvey: false,
  isSubmittingRpSurveyFormFeedback: false,
  rpGoaSchoolDetails: {},
};

export default handleActions({
    [actions.fetchAllFluences]: (state, action) => u({
        isFetchingFluences: true
    }, state),

    [actions.receiveAllFluences]: (state, action) => u({
      isFetchingFluences: false,
      fluences: action.payload.fluences
    }, state),

    [actions.fetchAllThemes]: (state, action) => u({
        isFetchingThemes: true,
    }, state),

    [actions.receiveAllThemes]: (state, action) => u({
      isFetchingThemes: false,
      fluencyThemes: action.payload.fluency
    }, state),

    [actions.fetchThemeDetails]: (state, action) => u({
      isFetchingThemeDetails: true
    }, state),

    [actions.receiveThemeDetails]: (state, action) => u({
        isFetchingThemeDetails: false,
        themeDetails: action.payload.themeDetails,
        nextThemeSuggestion: {}
    }, state),

    [actions.enrollUserToFluency]: (state, action) => u({
        isFetchingUserEnroll: true
    }, state),

    [actions.receiveenrollUserToFluency]: (state, action) => u({
        isFetchingUserEnroll: false,
        isUserEnrolled: action.payload.enrolled
    }, state),

    [actions.fetchUserEnrolled]: (state, action) => u({
      isCheckingUserEnrolled: true
    }, state),
//TODO: enrollmentDetails has to be modified
    [actions.receiveUserEnrolled]: (state, action) => u({
        isCheckingUserEnrolled: false,
        isUserEnrolled: action.payload.isEnrolled,
        enrollmentDetails: action.payload.data ? action.payload.data.enrollmentDetails : {}
    }, state),

    [actions.fetchStoryStatus]: (state, action) => u({
        isFetchingStoryStatus: true
    }, state),

    [actions.receiveStoryStatus]: (state, action) => u({
        isFetchingStoryStatus: false,
        storyStatus: action.payload.status,
        storyLabel: action.payload.label
    }, state),

    [actions.fetchFluenceProgress]: (state, action) => u({
      isFetchingFluencyProgress: true
    }, state),

    [actions.receiveFluenceProgress]: (state, action) => u({
      isFetechingFluenceProgress: false,
      fluenceProgress: action.payload.progress
    }, state),

    [actions.fetchNextSuggestion]: (state, action) => u({
        isFetchingNextSuggestion: true
    }, state),

    [actions.receiveNextSuggestion]: (state, action) => u({
        isFetchingNextSuggestion: false,
        nextSuggestion: action.payload.suggestion
    }, action),

    [actions.fetchEnrolledFluencies]: (state, action) => u({
        isFetchingEnrolledFluencies: true
    }, state),

    [actions.receiveEnrolledFluencies]: (state, action) => u({
        isFetchingEnrolledFluencies: false,
        userEnrolledFluency: action.payload.enrolledFluencies,
        showSurvey: action.payload.showSurvey
    }, state),

    [actions.openOnboardingForm]: (state, action) => u({
      isRpOnboardingModalVisible: true,
      rpUserType: '',
      rpsSelectNumberOfStudents: '',
    }, state),

    [actions.selectUserType]: (state, action) => u({
      rpUserType: action.payload,
      rpsSelectNumberOfStudents: '',
    }, state),

    [actions.selectNumberOfStudents]: (state, action) => u({
      rpsSelectNumberOfStudents: action.payload
    }, state),

    [actions.closeOnboardingForm]: (state, action) => u({
      isRpOnboardingModalVisible: false
    }, state),

    [actions.fetchNextStorySuggestion]: (state, action) => u({
        isFetchingNextSuggestion: true
    }, state),

    [actions.receiveNextStorySuggestion]: (state, action) => u({
        isFetchingNextSuggestion: false,
        nextStorySuggestion: action.payload.suggestion
    }, state),

    [actions.fetchNextThemeSuggestion]: (state, action) => u({
      isFetchingNextThemeSuggestion: true
    }, state),

    [actions.recieveNextThemeSuggestion]: (state, action) => u({
      isFetchingNextThemeSuggestion: false,
      nextThemeSuggestion:action.payload.nextThemeSuggestion
    }, state),

    [actions.fetchLandingPageImages]: (state, action) => u({
      isFetchingLandginPageImages: true
    }, state),

    [actions.recieveLandingPageImages]: (state, action) => u({
      isFetchingLandginPageImages: false,
      landingPagesImages: action.payload.readingProgramImages
    }, state),

    [actions.setStoryStatus]: (state, action) => u({
      isSettingStoryStatus: true
    }, state),

    [actions.receiveSetStoryStatus]: (state, action) => u({
      isSettingStoryStatus: false,
      readStoryStatus: action.payload.readStoryStatus
    }, state),

    [actions.goToFluencyTheme]: (state, action) => u({
        targetFluencyLevel: action.payload
    }, state),

    [actions.fetchLandingPageContent]: (state, action) => u({
      isFetchingLandingPageContent: true
    }, state),
    [actions.recieveLandingPageContent]: (state, action) => u({
      isFetchingLandingPageContent: false,
      landingPageContent: action.payload.data
    }, state),

    [actions.postRpSurveyFormFeedback]: (state, action) => u({
      isSubmittingRpSurveyFormFeedback: true
    }, state),
  
    [actions.receivePostRpSurveyFormFeedback]: (state, action) => u({
      isSubmittingRpSurveyFormFeedback: false
    }, state),
  
    [actions.postRpSurveyFormFeedbackError]: (state, action) => u({
      isSubmittingRpSurveyFormFeedback: false
    }, state),

    [actions.fetchThemePageContent]: (state, action) => u({
      isFetchingThemePageContent: true
    }, state),
    [actions.recieveThemePageContent]: (state, action) => u({
      isFetchingThemePageContent: false,
      themePageContent: action.payload.data
    }, state),

    [actions.fetchRpCertDownload]: (state, action) => u({
      isFetchingCertDownload: true
    }, state),

    [actions.recieveRpCertDownload]: (state, action) => u({
      isFetchingCertDownload: false,
    }, state),

    [actions.fetchRpCertDownloadError]: (state, action) => u({
      isFetchingCertDownload: false,
    }, state),

    [actions.receiveGoaSchoolDetails]: (state, action) => u({
      rpGoaSchoolDetails: action.payload.data,
    }, state),

  }, initialState);



// WEBPACK FOOTER //
// ./src/redux/allFluencesReducer.js